import { isDefined, isNotDefined } from './core.js';

function comparison(extractor, comparisonFunc) {
  return function (x, y) {
    let direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    const a = isDefined(x) ? extractor(x) : undefined;
    const b = isDefined(y) ? extractor(y) : undefined;
    if (a === b) {
      return 0;
    }
    if (isNotDefined(a)) {
      return direction * 1;
    }
    if (isNotDefined(b)) {
      return direction * -1;
    }
    return direction * comparisonFunc(a, b);
  };
}

// NOTE: func is never called for boolean
const compareBoolean = comparison(x => x, (a, b) => Number(a) - Number(b));
const compareString = comparison(x => x, (a, b) => a.localeCompare(b));
const compareNumber = comparison(x => x, (a, b) => a - b);
const compareDate = comparison(x => x, (a, b) => {
  const dateA = new Date(a);
  const dateB = new Date(b);
  return dateA.getTime() - dateB.getTime();
});
const compareStringAsNumber = comparison(x => Number(x), (a, b) => a - b);
const compareLength = comparison(x => x.length, (a, b) => a - b);
const compareStringByWordCount = comparison(x => x.split(/\s+/).length, (a, b) => a - b);
const compareStringSearch = (x, y, z, d) => {
  if (!z) {
    return 0;
  }
  return comparison(a => a, (a, b) => {
    const searchText = z.toLowerCase();
    const firstIndex = a.toLowerCase().indexOf(searchText);
    const secondIndex = b.toLowerCase().indexOf(searchText);
    if (firstIndex === secondIndex) {
      return a.localeCompare(b);
    }
    if (firstIndex === -1 && secondIndex === -1) {
      return a.localeCompare(b);
    }
    if (secondIndex === -1) {
      return -1;
    }
    if (firstIndex === -1) {
      return 1;
    }
    return firstIndex - secondIndex;
  })(x, y, d);
};

export { compareBoolean, compareDate, compareLength, compareNumber, compareString, compareStringAsNumber, compareStringByWordCount, compareStringSearch };
//# sourceMappingURL=comparision.js.map
